import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheckIcon } from 'lucide-react';
import { PromoCountdown } from './PromoCountdown';
import { pricing, warrantyCopy } from '../data/promotion';
import { useActiveSale } from '../hooks/useActiveSale';
import { money } from './QuantityStepper';

/**
 * The first pricing information a visitor sees: discount, regular vs launch
 * price, total separate value, the warranty and the weekly countdown.
 * The three prices ($166.60 value, $124.95 regular, $49.95 launch) are kept
 * visually distinct so they are never confused with each other.
 */
export function LaunchOfferPanel() {
  const sale = useActiveSale();
  return <div className="mt-8 grid gap-px border border-white/12 bg-white/10 lg:grid-cols-[1.25fr_1fr]" data-id="element-310" data-mp="17dzjp9jlf3nb">
      <div className="bg-ink-950 p-5 sm:p-7" data-id="element-311" data-mp="1v3k31tjns2x4">
        <div className="flex flex-wrap items-center gap-3" data-id="element-312" data-mp="1v2s72hm5g36b">
          <span className="bg-grit-500 px-3 py-1.5 font-display text-2xl font-extrabold uppercase leading-none text-ink-950 sm:text-3xl" data-id="element-313" data-mp="1zu0hngz7tul2">
            {pricing.discountPct}% off
          </span>
          <span className="text-[11px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-314" data-mp="288mu1tij2pfh">★ {sale.name}</span>
        </div>
        <p className="mt-3 max-w-xl text-[14px] font-medium text-steel-300" data-id="element-315" data-mp="2m0b1vklqurqn">{sale.tagline}</p>

        <p className="mt-5 flex flex-wrap items-end gap-x-4 gap-y-1" data-id="element-316" data-mp="2h8t4f6ixj9af">
          <span className="pb-1 text-lg text-steel-400" data-id="element-317" data-mp="2vy8oy4rvaiho">
            <span className="sr-only" data-id="element-318" data-mp="2vwnuef5jyzjt">Regular price </span>
            <span className="line-through" data-id="element-319" data-mp="2qznny34sjus6">{money(pricing.regular)}</span>
          </span>
          <span className="font-display text-6xl font-extrabold leading-none text-offwhite sm:text-7xl" data-id="element-320" data-mp="34ynczbw7ubov">
            {money(pricing.launch)}
          </span>
        </p>
        <p className="mt-2 font-display text-xl font-bold uppercase tracking-wide text-grit-500" data-id="element-321" data-mp="30v7ial3pilet">
          You save {money(pricing.save)} from the regular price
        </p>

        <dl className="mt-5 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2" data-id="element-322" data-mp="16klyx45qt9go">
          <div className="bg-ink-900 px-4 py-3" data-id="element-323" data-mp="35pcc7ledlqiy">
            <dt className="text-[10px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-324" data-mp="3an5i0dbroiip">Total separate value</dt>
            <dd className="mt-1 font-display text-3xl font-extrabold leading-none text-offwhite" data-id="element-325" data-mp="3flp4qfy6pyc4">
              {money(pricing.separateValue)}
            </dd>
          </div>
          <Link to="/legal/guarantee" className="flex items-center gap-3 bg-ink-900 px-4 py-3 transition-colors duration-150 ease-grit hover:bg-ink-850 focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500" data-id="element-326" data-mp="3kiyslr5xe1xu">
            <ShieldCheckIcon className="h-7 w-7 shrink-0 text-grit-500" aria-hidden="true" data-id="element-327" data-mp="28n1robo9wo0" />
            <span data-id="element-328" data-mp="75dlclmorae6">
              <span className="block text-[10px] font-bold uppercase tracking-[0.2em] text-steel-400" data-id="element-329" data-mp="75na65vzvbia">
                {warrantyCopy.value}
              </span>
              <span className="mt-0.5 block font-display text-lg font-bold uppercase leading-tight text-offwhite" data-id="element-330" data-mp="g6bpr511djxa">
                Lifetime warranty free on every multi-pack
              </span>
            </span>
          </Link>
        </dl>
      </div>

      <div className="flex flex-col justify-center bg-ink-950 p-5 sm:p-7" data-id="element-331" data-mp="1wpn6pks6prb8">
        <PromoCountdown data-id="element-332" data-mp="1rozfoz3yhah0" />
        <p className="mt-4 text-[13px] leading-relaxed text-steel-400" data-id="element-333" data-mp="1rqak91586m96">
          Every system ships complete: glasses, 3 lenses, hard case, pouch, cloth, USB cable, anti-fog spray, guide
          and authenticity card.
        </p>
      </div>
    </div>;
}